import config from '@/config';

const DEFAULT_GLS_PATH = '/api/game-launch';

export const buildGlsInitPath = (): string => {
  const glsPath = config.GLS?.GLSPath ?? DEFAULT_GLS_PATH;
  const normalized = glsPath.endsWith('/') ? glsPath.slice(0, -1) : glsPath;
  return `${normalized}/init`;
};
